import "./Access.css"
export default function AccessButton(props) {
    return props.ModuleDetails.map((md, index) => {
        return <span
            className="ApiTop"
            style={{
                backgroundColor: md.BackgroundColor,
                color: md.TitleForeColor
            }}
            key={index}
        >
            {md ? md.Title : ""}
        </span>
    })
}